// extracted by mini-css-extract-plugin
export default {"container":"Social_container__LKNKY","img":"Social_img__b4H9w","iconStyle":"Social_iconStyle__TplYc"};